import { createApi } from "@reduxjs/toolkit/query/react";
import { GET_PERMISSION_COMPANY, COA_ALL_LEVELS_2, CHART_OF_ACCOUNTS, DETAIL_TYPES, POST_COA } from "../constants";
import customBaseQuery from "../CustomBaseQuery/customBaseQuery";

export const coaAllLevelData = createApi({
  reducerPath: "coaAllLevelData",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCoaAllLevel: builder.query({
      query: ({ token }) => ({
        url: `${COA_ALL_LEVELS_2}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["CoaAllLevel"],
      keepUnusedDataFor: 0, // Disable caching
      refetchOnMountOrArgChange: true, // Refetch on mount or arg change
      // skip: (arg) => !arg.token,
    }),

    getAllCoaData: builder.query({
      query: ({ token, org_id, company_id, parent_account_code }) => {
        const url = `${CHART_OF_ACCOUNTS}?org_id=${org_id}&company_id=${company_id}${
          parent_account_code ? `&parent_account_code=${parent_account_code}` : ""
        }`;
        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
      keepUnusedDataFor: 0,
      invalidatesTags: ["CoaAllLevel"],
    }),

    getDetailTypes: builder.query({
      query: ({ token, account_code }) => ({
        url: `${DETAIL_TYPES}/${account_code}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["DetailTypes"],
      keepUnusedDataFor: 0, // Disable caching for fresh data
      refetchOnMountOrArgChange: true, // Refetch data when args change
    }),
    postCoaData: builder.mutation({
      query: ({ token, coaData }) => ({
        url: POST_COA,
        method: "POST",
        body: coaData, // This is the data you're posting to the server
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      // Tags to invalidate after mutation (e.g., invalidate cache)
      invalidatesTags: ["CoaAllLevel"],
    }),
    getCoaByCode: builder.query({
      query: (accountCode) => ({
        url: `${POST_COA}/${accountCode}`,
        method: "GET",
      }),
      // Optional: Tags for caching and invalidation
      //providesTags: (result, error, accountCode) => [{ type: 'Coa', id: accountCode }],
    }),
    putCoaData: builder.mutation({
      query: ({ token, accountCode, coaData }) => ({
        url: `${POST_COA}/${accountCode}`,
        method: "PUT",
        body: coaData,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["CoaAllLevel"],
    }),
  }),
});

export const {
  useFetchCoaAllLevelQuery,
  useGetAllCoaDataQuery,
  useLazyGetAllCoaDataQuery,
  useGetDetailTypesQuery,
  usePostCoaDataMutation,
  useGetCoaByCodeQuery,
  usePutCoaDataMutation,
} = coaAllLevelData;
